// Library methods

// Utils
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import { API_AUDIT_TRAIL_FETCH } from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as auditTrailActions from './auditTrail.actions';

// Constants
import { FETCH_AUDIT_TRAIL_REQUEST } from './auditTrail.constants';
import moment from 'moment';
import { takeLatest, put, call } from 'redux-saga/effects';

const getRequestData = payload => {
    const request = {
        pageNo: payload.pageNo || 1,
        pageSize: payload.pageSize || 10,
    };
    if (payload.createdOn) {
        request.startDateTime = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }
    if (payload.time) {
        const dateStrStart = moment(payload.createdOn.startDate);
        const dateStrEnd = moment(payload.createdOn.endDate);
        const timeStart = moment(payload.time.startTime, 'HH:mm');
        const timeEnd = moment(payload.time.endTime, 'HH:mm');

        dateStrStart.set({
            hour: timeStart.get('hour'),
            minute: timeStart.get('minute'),
            second: timeStart.get('second'),
        });

        dateStrEnd.set({
            hour: timeEnd.get('hour'),
            minute: timeEnd.get('minute'),
            second: timeEnd.get('second'),
        });

        request.startDateTime = dateStrStart.format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = dateStrEnd.format('YYYY-MM-DD HH:mm:ss');
    }
    if (payload.userId) {
        request.userId = payload.userId;
    }
    if (payload.action) {
        const { action } = payload;
        request.action = action;
    }
    if (payload.resource && payload.resource) {
        const { resource } = payload;
        request.resource = resource;
    }
    return request;
};

export function* fetchAuditTrailDetails(actions) {
    yield put(auditTrailActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(
            POST,
            API_AUDIT_TRAIL_FETCH,
            getRequestData(payload)
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(auditTrailActions.fetchAuditTrailSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                auditTrailActions.fetchAuditTrailError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(auditTrailActions.fetchAuditTrailError({ error: data }));
    }
    yield put(auditTrailActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* auditTrailSaga() {
    yield takeLatest(FETCH_AUDIT_TRAIL_REQUEST, fetchAuditTrailDetails);
}
